import React from 'react';
import { Text } from '@chakra-ui/react';
import StyledLink from '@components/general/styled-link.component';
import { useUserStore } from '@store/app.store';
import { usePersonById } from '@services/query-services/people.query-service';

function LensMeta({ lens }) {
  const user = useUserStore((state) => state?.user);
  const { data: lensCreator } = usePersonById(lens?.creator?.id, { enabled: !!lens?.creator?.id });

  return (
    <Text
      color='surface.onSurfaceVariant'
      lineHeight={1.5}
    >
      <Text as='span'>This page of insights was generated for&nbsp;</Text>
      <StyledLink to={`/person?email=${user?.email}&id=${user?.id}`}>{user?.name}</StyledLink>
      <Text as='span'>
        &nbsp;according to {user?.first_name}&apos;s personalization settings.&nbsp;
      </Text>
      <StyledLink to={`/lenses/${lens?.id}/edit`}>{lens?.title}</StyledLink>
      <Text as='span'>&nbsp;was created by&nbsp;</Text>
      <StyledLink to={`/person?email=${lensCreator?.email}&id=${lensCreator?.id}`}>
        {lensCreator?.name}
      </StyledLink>
      .
    </Text>
  );
}

export default LensMeta;
